import { type AnyRoute, createRoute } from "@tanstack/react-router";

import { F2fTransaction } from "./F2fTransaction";
import { OnlineTransaction } from "./OnlineTransaction";
import { V2Transaction } from "./V2Transaction";

export function createAdminF2fTransactionRoute<P extends AnyRoute>(parent: P) {
  return createRoute({
    getParentRoute: () => parent,
    path: "admin/f2f/transactions/$transactionId",
    component: F2fTransaction,
    staticData: { reducedMobileTopPadding: true },
    head: (ctx) => ({
      meta: [{ title: "F2F Transaction Details " + ctx.params.transactionId }],
    }),
  });
}

export function createAdminOnlineTransactionRoute<P extends AnyRoute>(
  parent: P,
) {
  return createRoute({
    getParentRoute: () => parent,
    path: "admin/online/transactions/$transactionId",
    component: OnlineTransaction,
    staticData: { reducedMobileTopPadding: true },
    head: (ctx) => ({
      meta: [
        { title: "Online Transaction Details " + ctx.params.transactionId },
      ],
    }),
  });
}

export function createAdminV2TransactionRoute<P extends AnyRoute>(parent: P) {
  return createRoute({
    getParentRoute: () => parent,
    path: "admin/v2/transactions/$transactionId",
    component: V2Transaction,
    staticData: { reducedMobileTopPadding: true },
    head: (ctx) => ({
      meta: [{ title: "V2 Transaction Details " + ctx.params.transactionId }],
    }),
  });
}
